export enum StatusPillVariants {
  SUCCESS = 'success',
  PENDING = 'pending',
  ERROR = 'error'
}

export enum TemplateIDNames {
  DEFAULT = 'Default',
  NO_DISPATCH = 'No Dispatch',
  RP1_BEFORE_DISPATCH = 'RP 1 Before Dispatch',
  DURESS_POLICE = 'Burglar Alarms-Guard/Duress-Police',
  LOG_ONLY = 'Log Only',
  CROSS_ZONE = 'Cross-Zone',
  DURESS_GUARD = 'Burglar Alarms-Guard/Duress-Guard',
  BURG_DURESS_NO_DISPATCH = 'Burg & Duress - No Dispatch',
  DURESS_NO_DISPATCH = 'Duress - No Dispatch'
}

export const TemplateIDNameToValueMap: Record<TemplateIDNames, number> = {
  [TemplateIDNames.DEFAULT]: 1,
  [TemplateIDNames.NO_DISPATCH]: 2,
  [TemplateIDNames.RP1_BEFORE_DISPATCH]: 3,
  [TemplateIDNames.DURESS_POLICE]: 4,
  [TemplateIDNames.LOG_ONLY]: 5,
  [TemplateIDNames.CROSS_ZONE]: 6,
  [TemplateIDNames.DURESS_GUARD]: 7,
  [TemplateIDNames.BURG_DURESS_NO_DISPATCH]: 8,
  [TemplateIDNames.DURESS_NO_DISPATCH]: 9
}

export const TemplateIDNameValues = [
  { name: TemplateIDNames.DEFAULT, value: 1 },
  { name: TemplateIDNames.NO_DISPATCH, value: 2 },
  { name: TemplateIDNames.RP1_BEFORE_DISPATCH, value: 3 },
  { name: TemplateIDNames.DURESS_POLICE, value: 4 },
  { name: TemplateIDNames.LOG_ONLY, value: 5 },
  { name: TemplateIDNames.CROSS_ZONE, value: 6 },
  { name: TemplateIDNames.DURESS_GUARD, value: 7 },
  { name: TemplateIDNames.BURG_DURESS_NO_DISPATCH, value: 8 },
  { name: TemplateIDNames.DURESS_NO_DISPATCH, value: 9 }
]
